export default "__VITE_ASSET__ml3rNVR4__"